<div class="order-card" [class.order-card-show-tickets]="showTickets">
  @if (order.tickets[0]) {
    <div class="order-card-header">
      <p class="order-card-title">{{ order.tickets[0].event_title }}</p>
      <span class="status status--{{ order.payment_status | orderPaymentStatusClass }}">
        {{ paymentStatusLabel }}
      </span>
    </div>
    <div class="event-info-area">
      <div class="event-banner-area">
        <img
          appImgFallback="./../../../../assets/images/evento-sem-imagem.svg"
          [src]="loadEventImage(order.tickets[0].event_thumbnail)"
          [class.grayscale]="isPastEvent"
          alt="Banner do evento" />
      </div>
      <div class="event-details-area">
        <p>
          {{ order.tickets[0].event_start_date | date: "shortDate" }} -
          {{ order.tickets[0].event_start_date | date: "shortTime" }}
        </p>
        <p>{{ order.tickets[0].event_location.location_name }}</p>
        <p>{{ order.tickets[0].event_location.street }} - {{ order.tickets[0].event_location.number }}</p>
        <p>{{ order.tickets[0].event_location.city_name }} - {{ order.tickets[0].event_location.state }}</p>
      </div>
    </div>
  } @else {
    <div class="order-card-header">
      <p class="order-card-title">#{{ order.id }}</p>
      <span class="status status--{{ order.payment_status | orderPaymentStatusClass }}">
        {{ paymentStatusLabel }}
      </span>
    </div>
    <div class="event-info-area">
      <div class="col-span-2">Sem ingressos disponíveis</div>
    </div>
  }

  <div class="order-details-area">
    <div class="payment-details">
      @if (order.payment_status === orderPaymentStatus.Courtesy) {
        <p><b>Pedido recebido por convite</b></p>
      } @else if (order.payment_status === orderPaymentStatus.Transferred) {
        <p><b>Pedido recebido por transferência</b></p>
      } @else {
        <p><b>Total da Compra: </b> {{ order.total_amount | currency: "BRL" }}</p>
        <p>Pagamento feito via {{ order.payment_method | paymentMethod }}</p>
      }
    </div>
    <div><b>Ingressos: </b> {{ order.tickets.length }} {{ order.tickets.length > 1 ? "unidades" : "unidade" }}</div>
  </div>

  @if (showRemainingPaymentPrompt) {
    <div class="refund-status-area" data-testid="remaining-payment">
      <div class="refund-status refund-status--pending">
        <i class="pi pi-clock"></i>
        <span>
          Pagamento pendente — falta {{ remainingPaymentReais | currency: "BRL" }}. Finalize com outro meio ou solicite o
          estorno do valor já pago.
        </span>
      </div>
    </div>
  }

  @if (!isPaymentFailed()) {
    <div class="tickets-sections" [hidden]="!showTickets">
      @for (group of spaceGroups; track group.spaceId) {
        <div class="tickets-section">
          <div class="tickets-section__header">
            <i class="pi pi-building"></i>
            <span>{{ group.title }}</span>
            <span class="tickets-section__count">{{ group.tickets.length }} ingressos</span>
          </div>
          <div class="tickets-section__list">
            @for (ticket of group.tickets; track ticket.id) {
              <app-ticket-card
                [ticket]="ticket"
                [restrictToEventAction]="ticketActionsRestricted"
                (reloadTicketsAfterChange)="handleReloadTicketsAfterChange()" />
            }
          </div>
        </div>
      }

      @if (regularTickets.length > 0) {
        <div class="tickets-section">
          <div class="tickets-section__header">
            <i class="pi pi-ticket"></i>
            <span>Ingressos</span>
            <span class="tickets-section__count">{{ regularTickets.length }} ingressos</span>
          </div>
          <div class="tickets-section__list">
            @for (ticket of regularTickets; track ticket.id) {
              <app-ticket-card
                [ticket]="ticket"
                [restrictToEventAction]="ticketActionsRestricted"
                (reloadTicketsAfterChange)="handleReloadTicketsAfterChange()" />
            }
          </div>
        </div>
      }
    </div>
  }

  @if (isPaymentFailed()) {
    <div class="refund-status-area">
      <div class="refund-status refund-status--error">
        <i class="pi pi-times-circle"></i>
        <span>Não foi possível processar o pagamento desta compra. Os ingressos não foram emitidos.</span>
      </div>
    </div>
  }

  @if (isRefundInAnalysis && !isRefundApproved) {
    <div class="refund-status-area" data-testid="refund-pending">
      <div class="refund-status refund-status--pending">
        <i class="pi pi-clock"></i>
        <span>Reembolso em análise</span>
      </div>
    </div>
  }

  @if (isRefundApproved) {
    <div class="refund-status-area" data-testid="refund-approved">
      <div class="refund-status refund-status--warning">
        <i class="pi pi-check-circle"></i>
        <span>Reembolso aprovado</span>
      </div>
    </div>
  }

  @if (isRefundRejected) {
    <div class="refund-status-area" data-testid="refund-rejected">
      <div class="refund-status refund-status--error">
        <i class="pi pi-times-circle"></i>
        <span>Reembolso recusado</span>
      </div>
    </div>
  }

  <div class="actions-area">
    @if (order.tickets.length > 0 && !isPaymentPending() && !isPaymentFailed()) {
      <app-button
        (btnClick)="toggleTickets()"
        styleType="outlined-secondary"
        [icon]="showTickets ? 'pi pi-chevron-up' : 'pi pi-chevron-down'">
        {{ showTickets ? "Ocultar" : "Visualizar" }} ingressos
      </app-button>
    }
    @if (showRemainingPaymentPrompt) {
      <app-button
        styleType="outlined-secondary"
        data-testid="finalize-remaining-payment-btn"
        (btnClick)="handleFinalizeRemainingPayment()">
        <i class="pi pi-credit-card"></i> Finalizar pagamento
      </app-button>
    }
    @if (canShowRefundButton()) {
      <span [matTooltip]="refundReasonTooltip" matTooltipPosition="above">
        <app-button
          styleType="outlined-secondary"
          data-testid="request-refund-btn"
          [disabled]="!canRequestRefund()"
          (btnClick)="requestRefund()">
          <i class="pi pi-wallet"></i>
          {{ hasRemainingPayment ? "Pedir estorno" : "Solicitar Reembolso" }}
        </app-button>
      </span>
    }

    <app-button (click)="handleOpenModalClick(order)" styleType="outlined-secondary">
      <i class="pi pi-eye"></i> Detalhes
    </app-button>
  </div>

  @if (loading) {
    <app-loading />
  }
</div>
